module.exports = __webpack_public_path__ + "static/media/Clustering Illusion.579e27cc.jpg";